/**
 * 媒体账号状态枚举
 */
export const MEDIA_ACCOUNT_STATUE_LIST = [
  {
    label: '全部状态',
    translateKey: 'components:t98',
    value: null,
  },
  {
    label: '生效中',
    translateKey: 'components:t100',
    value: 'ENABLED',
  },
  {
    label: '权限不足',
    translateKey: 'components:t101',
    value: 'LIMITED',
  },
  {
    label: '已失效',
    translateKey: 'components:t99',
    value: 'DISABLED',
  },
]
